<template>
    <div class="stages-detail-page">
        <Header></Header>
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Gallery</h2>
                        <form class="form" v-on:submit.prevent="uploadImgages" enctype="multipart/form-data">
                            <div class="input-file-field form-input">
                                <p>Gallery Image *</p>
                                <label for="video_image">
                                    <span>{{ImageFileName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="video_image" ref="ImageFile" v-on:change="handleFileUpload">
                            </div>
                            <div class="input-textarea-field form-input">
                                <progress-bar
                                        v-if="progressFlag"
                                        :options="options"
                                        :value="value"
                                />
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section class="gallery-listing">
            <div class="container">
                <div class="row">
                    <div class="col-md-3" v-for="(list) in lists" v-bind:key="list.id">
                        <div class="gallery-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.galleryImage})` }">
                            <img :src="closeImage" v-on:click="deleteFunction" :data-id="list._id" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>


<script>
    import Vue from 'vue'
    import Header from './Header'
    import Footer from './Footer'
    import router from '../router'
    import $ from "jquery"
    import axios from 'axios'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import image from '@/assets/img/image6.jpg'
    import closeImage from '@/assets/img/close.svg'
    Vue.use(VueToast)

    export default {
        name: 'Gallery',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        data () {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            } else {
                router.push({ name: 'Login' })
            }
            var options = {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#2dbd2d',
                    backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                    width: 445,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                value: 1,
                image: image,
                closeImage: closeImage,
                options: options,
                progressFlag: false,
                userData: userdata,
                FormSubmited: false,
                imageUrl: process.env.imageUrl,
                ImageFile: 'Image file',
                ImageFileName: 'Image file',
                lists: '',
                model: 'Gallery'
            }
        },
        mounted () {
           this.getGallery()
        },
        methods: {
            getGallery: function(){
                axios
                    .get('/getGallery', {
                        params: {
                            artistId: this.userData.user.id
                        }
                    })
                    .then(response => {
                        this.lists = response.data
                    })
                    .catch(error => {
                        Vue.$toast.open(
                            {
                                message: error.response.data,
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    })
            },
            progressDelay: function(){
                var numberOfTimes = ''
                var delay = ''
                var $this = this
                if(this.value === 1){
                    numberOfTimes = 98
                    delay = 300
                } else {
                    numberOfTimes = 100 - this.value
                    delay = 10
                }
                for (let i = 0; i < numberOfTimes; i++) {
                    setTimeout( function () {
                        if($this.value < 100){
                            $this.value = $this.value + 1
                        }
                    }, delay * i)
                }
            },
            handleFileUpload(){
                this.ImageFile = this.$refs.ImageFile.files[0]
                this.ImageFileName = this.$refs.ImageFile.files[0].name
            },
            async uploadImgages () {
                if(this.ImageFileName != 'Image file'){
                    this.FormSubmited = true
                    this.progressFlag = true
                    this.progressDelay()
                    const formData = new FormData()
                    formData.append('GalleryImageFile', this.ImageFile)
                    formData.append('GalleryImageFileHD', this.ImageFile)
                    formData.append('artistId', this.userData.user.id)
                    axios.post('/galleryImageFile', formData,{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        this.FormSubmited = false
                        this.progressFlag = false
                        this.ImageFile = 'Image file'
                        this.ImageFileName = 'Image file'
                        this.getGallery()
                        console.log(res)
                    }).catch(err => {
                        this.FormSubmited = false
                        this.progressFlag = false
                        this.ImageFile = 'Image file'
                        this.ImageFileName = 'Image file'
                        console.log(err)
                    })
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Please add image!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            },
            deleteFunction: function (event) {
                axios.post('/delete', {
                    id: event.target.dataset.id,
                    model: this.model
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(function (response) {
                    Vue.$toast.open(
                        {
                            message: 'Deleted successfully!',
                            type: 'success',
                            position: 'top-right'
                        }
                    )
                    $(event.target).closest('.col-md-3').detach()
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue